import { Component, HostListener, output, signal } from '@angular/core';

@Component({
  selector: 'app-header',
  imports: [],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  readonly show = signal(false);
  readonly chatBoxEvent = output<boolean>();

  @HostListener('document:click')
  public onDocumentClick(): void {
    this.show.set(false);
    this.chatBoxEvent.emit(false);
  }

  public openDialog(): void {
    this.show.update((value) => !value);
    this.chatBoxEvent.emit(this.show());
  }
}
